import React from 'react';

import Icon from '../../Icons';
import CardTooltip from '../../CardTooltip';

import { clearInputMask } from '../../../utils';

import Loading from '../../Loading';

import { useGlobal } from '../../../contexts/Global/context';

import * as S from './styles';
import * as Styles from '../styles';

function TextAreaInput({ field, onChange, loading, field: { icon: InputIcon }, ...rest }) {
    const { contrastTheme } = useGlobal();

    function handleChangeInput(event) {
        const { id } = event.target;

        if (field.regex && event.target.value) {
            const treatedValue = event.target.value.match(RegExp(field.regex, ['g']));

            event.target.value = treatedValue ? treatedValue.join('') : null;
        }

        const unmaskedValue = clearInputMask(event.target.value);

        event.target.unmaskedValue = unmaskedValue;

        if (typeof onChange === 'function') onChange({ id, value: event.target.value, unmaskedValue });
    }

    const defaultConfig = {
        alwaysShowMask: false,
        maskChar: null,
        formatChars: {
            9: '[0-9]',
            a: '[A-Za-z]',
            '*': '[A-Za-z0-9 ]',
            b: '[A-Za-z ]',
        },
    };

    return (
        <Styles.FormGroup>
            <label>
                {field.label && `${field.label} ${!field.required && !field.disabled ? ' (opcional)' : ''}`}
                {field.help && (
                    <CardTooltip message={field.help}>
                        <Styles.ContainerHelp>
                            <Icon name="info" size={18} color={contrastTheme ? '#FFFFFF' : '#EC6E0C'} />
                        </Styles.ContainerHelp>
                    </CardTooltip>
                )}
            </label>
            <S.ContainerInput>
                <S.StyledInput
                    id={field.id}
                    placeholder={field.placeholder}
                    value={field.value}
                    disabled={field.disabled}
                    autoComplete="new-password"
                    style={InputIcon && { paddingRight: '35px' }}
                    className={`${field.error ? 'error' : ' '} ${field.disabled ? 'disabled' : ' '}`}
                    onChange={handleChangeInput}
                    {...defaultConfig}
                    {...rest}
                />
                {field.loading && <Loading padding="0px" size={20} />}
                {!field.loading && InputIcon && (
                    <div className="icon-container">
                        <InputIcon color={contrastTheme ? '#FFFFFF' : '#EC6E0C'} />
                    </div>
                )}
            </S.ContainerInput>
            {field.error && <Styles.SpanError>{field.error}</Styles.SpanError>}
        </Styles.FormGroup>
    );
}

export default TextAreaInput;
